import {ENDPOINTS} from '~/constants';
import {FetchParams, PostParams, PutParams, DeleteParams} from 'redux-thunk-kit';

import {TestimonialEntity, NormalizedTestimonial} from '~/types/models/testimonial';
import {testimonialSchema} from '~/redux/testimonials/entity-config';
import {thunk} from '~/utils/thunk';

export interface FetchTestimonialsParams extends FetchParams {}

export interface AddTestimonialParams extends PostParams {
  data: Partial<TestimonialEntity>;
}

export interface UpdateTestimonialParams extends PutParams {
  data: Partial<TestimonialEntity>;
  id: number;
}

const query = thunk.query<TestimonialEntity, NormalizedTestimonial>('testimonial', testimonialSchema);
export const fetchTestimonials = query.fetch<FetchTestimonialsParams>(ENDPOINTS.TESTIMONIALS);
export const addTestimonial = query.post<AddTestimonialParams>(ENDPOINTS.TESTIMONIALS);
export const updateTestimonial = query.put<UpdateTestimonialParams>(`${ENDPOINTS.TESTIMONIALS}/:id`);
export const deleteTestimonial = query.delete<DeleteParams>(`${ENDPOINTS.TESTIMONIALS}/:id`);
